@let controlVariable = control();
@if(controlVariable){
	<div *transloco="let t;" class="text-danger">
		@if(controlVariable.errors && (controlVariable.touched || showErrors())){

			@if(controlVariable.errors['required']){
				<div>{{ t('common.required') }}</div>
			}

			@if(controlVariable.errors	['minlength']){
				<div>{{ t('common.too_short') }}</div>
			}

			@if(controlVariable.errors['maxlength']){
				<div>{{ t('common.too_long') }}</div>
			}

		}
	</div>
}